"use client"

import axios from "axios"
import { useState, useEffect } from "react"
import { useLocation, useNavigate } from "react-router"

const FormEnd = () => {
  const [isDownloading, setIsDownloading] = useState(false)
  const location = useLocation();
  const [user, setUser] = useState(localStorage.getItem("userId")|| null);
  const navigate = useNavigate();
  useEffect(() => {
    if (!user ) {
      navigate('/', { replace: true })
    } else if (!localStorage.getItem("hasSubmitted")) {
      navigate('/feedback', {replace:true})
    }
  })
  const handleCertificateDownload = async () => {
    setIsDownloading(true)

    try {
      const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}api/download-certificate/${user}`,
      { responseType: "arraybuffer" } // 👈 important
    );

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `certificate.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
      setIsDownloading(false);
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <div className="form-end">
      <h1 className="thank-you-title">Thank You!</h1>
      <p className="thank-you-message" style={{margin:0}}>
        Your feedback has been successfully submitted.
      </p>
      <p className="thank-you-message" style={{margin:0}}>
         We truly appreciate you taking the time to share your thoughts on the workshop. Your input is invaluable in helping us enhance our future session
      </p>

      <button className="certificate-btn" onClick={handleCertificateDownload} disabled={isDownloading || !user}>
        {isDownloading ? "Preparing..." : "Download Certificate"}
      </button>
    </div>
  )
}

export default FormEnd
